import { ThemeProvider, lightTheme } from '@comfama/comfama-ui';
import './src/styles/main.scss';
import './src/styles/global.css';

export const wrapPageElement = ({ element }) => (
  <ThemeProvider customDarkTheme={lightTheme}>{element}</ThemeProvider>
);

export const onRouteUpdate = ({ location, prevLocation }) => {
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
  }, 1);
};
